import {
  EventAnalyticsGuestsDto,
  EventAnalyticsGuestsSortBy
} from 'legacy/events/types';
import { getEventAnalyticsGuests } from '../service';
import { useCursorQuery } from 'helpers/queries/useCursorQuery';

export function useGetEventAnalyticsGuests({
  eventId,
  numberOfItems,
  sort,
  order,
  query
}: {
  eventId: string;
  cursor?: string;
  numberOfItems?: number;
  sort?: EventAnalyticsGuestsSortBy;
  order?: 'asc' | 'desc';
  query?: string;
}) {
  const { data, ...rest } = useCursorQuery<EventAnalyticsGuestsDto>(
    ['data', eventId, numberOfItems, sort, order, query],
    (_, fetchCursor) =>
      getEventAnalyticsGuests({
        eventId,
        cursor: fetchCursor,
        numberOfItems,
        order,
        sort,
        query
      }),
    {
      keepPreviousData: true,
      select: (data) => ({
        ...data,
        currentPage: data.currentPage + 1
      })
    }
  );

  return {
    data: data || null,
    ...rest
  };
}
